import { Lightning, Utils } from "@lightningjs/sdk"

export default class ParentalButton extends Lightning.Component {
    static override _template() {
        return {
            w: (w) => w,
            h: 60,
            rect: true,
            collision: true,
            zIndex: 83,
            color: 0xff111111,
            shader: { type: Lightning.shaders.RoundedRectangle, radius: 6 },
            flex: {
                direction: "row",
                alignItems: "center",
                padding: 10,
            },
            Icon: {
                w: 50,
                h: 50,
                x: 10,
                visible: false,
            },
            Label: {
                x: 40,
                text: {
                    text: this.bindProp('label'),
                    fontSize: 28,
                    textColor: 0xffffffff,
                },
            },
        };
    }

    // override _getFocused(): Lightning.Component | null | undefined {
    //     return this.tag('Button')!
    // }

    set icon(src) {
        if (src) {
            this.tag("Icon").patch({
                src: Utils.asset(src),
                visible: true,
            });
            this.tag("Label").x = 40;
        } else {
            this.tag("Label").x = 40;
        }
    }

    override _focus() {
        this.patch({
            smooth: { color: 0xffffffff, scale: 1.1 },
            Label: { text: { textColor: 0xff000000 } }
        });
    }

    override _unfocus() {
        this.patch({
            smooth: { color: 0xff111111, scale: 1 },
            Label: { text: { textColor: 0xffffffff } }
        });
    }

}
